module.exports = __webpack_public_path__ + "static/media/facebook.cf245b3a.png";